import { render } from "./ResetPasswordComponent.vue?vue&type=template&id=f9fe7546&scoped=true"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=js"

import "./ResetPasswordComponent.vue?vue&type=style&index=0&id=f9fe7546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fe7546"]])

export default __exports__